<template>
  <PageArticleList
    :header-configuration="headerConfiguration"
    :init-articles="articles"
    :init-page="page"
    :init-per-page="perPage"
    :total="total"
  />
</template>

<script>
import AppRouteMixin from '~/mixins/AppRouteMixin'
import PageArticleList from '@theme/components/content/PageArticleList'

const PAGE = {
  name: 'RouteArticleList',
  nuxtI18n: {
    paths: {
      cs: '/clanky',
      de: '/artikel',
      en: '/articles',
      sk: '/clanky',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageArticleList,
  },
  mixins: [AppRouteMixin],
  async asyncData({ app, store, query, redirect, req, res }) {
    if (process.server) {
      res.set('X-Inspishop-Cache-Control', `public, max-age=${app.$env.STATELESS_TTL}`)
    }

    // Handle duplicates
    if (query.p === '0') {
      delete query.p
      redirect(301, req.path, query)
      return
    }

    const page = Number(query.p) > 0 ? Number(query.p) : 0
    const perPage = app.$themeSettings.components.ArticleList.perPage

    const { entities, total } = await store.dispatch('article/LOAD_ARTICLES', { page, perPage })
    store.commit('locale/SET_CANONICALS')
    await store.dispatch('menu/FETCH_MENU', 'article')
    await store.dispatch('article/FETCH_CATEGORIES')
    await store.dispatch('article/FETCH_TAGS')
    return {
      articles: entities,
      headerConfiguration: await store.dispatch('article/LOAD_HEADER_CONFIGURATION'),
      page,
      perPage,
      total: total || 0,
    }
  },
}
export default PAGE
</script>
